export const SceneLights = () => (
  <>
    {/* Soft global illumination */}
    <ambientLight intensity={0.25} />

    {/* Key light – main shape & shadow */}
    <directionalLight
      position={[6, 8, 6]}
      intensity={1.4}
      castShadow
      shadow-mapSize-width={2048}
      shadow-mapSize-height={2048}
    />

    {/* Fill light – softens shadows */}
    <directionalLight
      position={[-6, 4, 4]}
      intensity={0.6}
    />

    {/* Rim / Back light – adds glow & separation */}
    <directionalLight
      position={[0, 5, -8]}
      intensity={0.9}
      color="#e6f4ff"
    />

    {/* Subtle front highlight */}
    <pointLight
      position={[0, 2, 4]}
      intensity={0.4}
      distance={10}
    />
  </>
);
